module.exports = __webpack_public_path__ + "img/rec-icon.70e0c2b0.svg";